import { ACTION_TYPES, useConselhosDispatch, useConselhosState } from "./conselhos-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { IConselhoPagedRequest } from "models/request/conselho-paged-request";
import { downloadFile } from "utils/download-file";

export const useConselhosController = () => {
    const dispatch = useConselhosDispatch();
    const { conselhoPagedRequest } = useConselhosState();

    async function exportConselhos(format: string) {
        const file = await MunicipalPortalAAppService.exportConselhos(conselhoPagedRequest, format);
        downloadFile(file);
    }

    async function onInit() {
        let request = { page: 0, pageSize: 10 } as IConselhoPagedRequest;

        dispatch({ type: ACTION_TYPES.setConselhoPagedRequest, payload: request });
        dispatch({ type: ACTION_TYPES.setLoading, payload: true });

        await listConselhos(request);
        await loadLookups();

        dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    async function loadLookups() {
        try {
            const [areas, ultimaAtualizacao] = await Promise.all([
                MunicipalPortalAAppService.listAreasTransparenciaSetorial(),
                MunicipalPortalAAppService.getConselhosUltimaAtualizacao()
            ]);
            dispatch({ type: ACTION_TYPES.setAreas, payload: areas });
            dispatch({ type: ACTION_TYPES.setUltimaAtualizacao, payload: ultimaAtualizacao?.dtaUltimaAtualizacao ?? null });
        } catch (error) {
            console.log(error);
        }
    }

    async function listConselhos(request: IConselhoPagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                dispatch({ type: ACTION_TYPES.setLoading, payload: true });
            }
            dispatch({ type: ACTION_TYPES.setError, payload: null });

            const conselhos = await MunicipalPortalAAppService.listConselhos(request);

            dispatch({ type: ACTION_TYPES.setConselhos, payload: conselhos });
        } catch (error) {
            console.log(error);
            dispatch({ type: ACTION_TYPES.setError, payload: 'Não foi possível carregar os conselhos. Tente novamente mais tarde.' });
        } finally {
            if (showLoading) {
                dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            }
        }
    }

    const handleOnChange = (e: any) => {
        let updated = { ...conselhoPagedRequest };

        if (e.target.name === "text-field-term") {
            updated.term = e.target.value;
            if (!updated.term) {
                (async () => await listConselhos({ ...updated, page: 0 }, true))();
            }
        } else if (e.target.name === "select-area-id") {
            updated.idAreaTransparenciaSetorial = e.target.value;
        } else if (e.target.name === "select-order-direction") {
            updated.orderDirection = e.target.value;
            (async () => await listConselhos({ ...updated, page: 0 }, true))();
        }

        dispatch({ type: ACTION_TYPES.setConselhoPagedRequest, payload: updated });
    };

    return { listConselhos, handleOnChange, onInit, exportConselhos };
}
